/**
 * Favourite reports, stored in the client database exactly like
 * MyFashionManager does (users_myreports: userid + repid), so the stars are
 * shared with MyFashionManager. The user is the one of the API key (auth
 * resolves it server side); SoftTouch logins all work as user 1001.
 *
 * Only reports (table report) can be favourites: "Mijn lijsten" (my_report)
 * use their own repid range and are not listed in MySoftTouch.
 */
import SftGlobalData from './SftGlobalData';

/** Earlier builds kept favourites in localStorage: read once, then migrated. */
const LEGACY_PREFIX = 'sft_report_favorites_';

export const legacyFavoritesKey = (db, login) => LEGACY_PREFIX + String(db || '') + '_' + String(login || '');

/** Resolves the repids that are favourites, or null when the call failed. */
export const fetchFavorites = (key) => SftGlobalData.post('reports&action=fetchFavorites', { key })
    .then(response => (typeof response.error === 'undefined' && Array.isArray(response?.data?.favorites)
        ? response.data.favorites.map(Number)
        : null))
    .catch(() => null);

/** Resolves true when the server stored the new state. */
export const saveFavorite = (key, repid, favorite) => SftGlobalData.post('reports&action=toggleFavorite', { key, repid, favorite })
    .then(response => typeof response.error === 'undefined')
    .catch(() => false);

/**
 * Report repids of the old browser favourites ('r:12'); 'm:' entries (Mijn
 * lijsten) are dropped. Empty when nothing is stored or storage is blocked.
 */
export const readLegacyFavorites = (legacyKey) => {
    try {
        const raw = window.localStorage.getItem(legacyKey);
        const list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list)
            ? list.map(String).filter(id => id.indexOf('r:') === 0).map(id => Number(id.slice(2))).filter(n => n > 0)
            : [];
    } catch (e) {
        return [];
    }
};

export const clearLegacyFavorites = (legacyKey) => {
    try {
        window.localStorage.removeItem(legacyKey);
    } catch (e) {
        // storage unavailable - nothing to clear
    }
};
